import React, { useState, useEffect } from 'react';
import api from '../../utils/axios'; // use your configured axios instance
import Swal from 'sweetalert2';

const AdminProfile = () => {
  const [profile, setProfile] = useState({
    name: '',
    email: '',
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [loading, setLoading] = useState(false);

  // Optional: Load admin profile from backend on mount
  useEffect(() => {
    async function fetchProfile() {
      try {
        // This endpoint must return admin's name and email
        const { data } = await api.get('/admin/profile');
        setProfile(prev => ({
          ...prev,
          name: data.name || '',
          email: data.email || ''
        }));
        // Save in localStorage for quick reloads
        localStorage.setItem('adminData', JSON.stringify({ name: data.name, email: data.email }));
      } catch (err) {
        // Fallback: use localStorage if backend endpoint is not present
        const adminData = JSON.parse(localStorage.getItem('adminData') || '{}');
        setProfile(prev => ({
          ...prev,
          name: adminData.name || '',
          email: adminData.email || ''
        }));
      }
    }
    fetchProfile();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfile(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (profile.newPassword) {
      if (profile.newPassword !== profile.confirmPassword) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'New passwords do not match',
          confirmButtonColor: '#000'
        });
        return;
      }
      if (!profile.currentPassword) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Current password is required to change password',
          confirmButtonColor: '#000'
        });
        return;
      }
    }

    setLoading(true);

    try {
      // Adjust endpoint as per your backend (must be /api/admin/profile)
      await api.put('/admin/profile', {
        name: profile.name,
        email: profile.email,
        currentPassword: profile.currentPassword,
        newPassword: profile.newPassword
      });

      // Update local storage
      localStorage.setItem('adminData', JSON.stringify({
        name: profile.name,
        email: profile.email
      }));

      // Clear password fields after update
      setProfile(prev => ({
        ...prev,
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      }));

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Profile updated successfully',
        confirmButtonColor: '#000'
      });
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'Failed to update profile',
        confirmButtonColor: '#000'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-6">Profile Settings</h1>
      <div className="bg-white rounded-lg shadow p-6 max-w-2xl">
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Basic Info */}
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Name
              </label>
              <input
                type="text"
                name="name"
                value={profile.name}
                onChange={handleInputChange}
                className="w-full p-2 border rounded focus:ring-black focus:border-black"
                required
                disabled={loading}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Email
              </label>
              <input
                type="email"
                name="email"
                value={profile.email}
                onChange={handleInputChange}
                className="w-full p-2 border rounded focus:ring-black focus:border-black"
                required
                disabled={loading}
              />
            </div>
          </div>

          {/* Change Password */}
          <div className="border-t pt-6">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Change Password</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Current Password
                </label>
                <input
                  type="password"
                  name="currentPassword"
                  value={profile.currentPassword}
                  onChange={handleInputChange}
                  className="w-full p-2 border rounded focus:ring-black focus:border-black"
                  disabled={loading}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  New Password
                </label>
                <input
                  type="password"
                  name="newPassword"
                  value={profile.newPassword}
                  onChange={handleInputChange}
                  className="w-full p-2 border rounded focus:ring-black focus:border-black"
                  disabled={loading}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Confirm New Password
                </label>
                <input
                  type="password"
                  name="confirmPassword"
                  value={profile.confirmPassword}
                  onChange={handleInputChange}
                  className="w-full p-2 border rounded focus:ring-black focus:border-black"
                  disabled={loading}
                />
              </div>
            </div>
          </div>

          {/* Submit Button */}
          <div className="flex justify-end">
            <button
              type="submit"
              className="px-4 py-2 bg-black text-white rounded hover:bg-gray-900 disabled:bg-gray-300"
              disabled={loading}
            >
              {loading ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminProfile;
